import React, { useState, useEffect } from 'react';
import { useLayout } from '../../LayoutContext';
import { CurrentPlanStyle } from './formsStyle';
import cornerRightArrow from '../../components/assets/corner-right-down.svg';
import Logo from '../../components/assets/sulamerica-pride.svg';
import Header from '../../components/header/Header';
import imageSource from '../../components/assets/plano-atual.webp';
import { useNavigate } from 'react-router-dom';
import FooterSend from '../../components/footer/FooterSend';
import videoSource from '../../components/assets/Video_forms.mp4';

const FormCurrentPlan = () => {
  const navigate = useNavigate();

  const { setLayoutConfig } = useLayout(); // Usa o hook para acessar a função de configuração

  useEffect(() => {
    // Configura a cor de fundo e o conteúdo do cabeçalho específicos para HomePage
    setLayoutConfig({
      backgroundColor: '#00022D',
      headerContent: {
        // Defina aqui os dados específicos do cabeçalho para a HomePage
      },
    });
  }, [setLayoutConfig]);

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null); // null inicialmente, para não ter opção selecionada
  const [providerName, setProviderName] = useState('');

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleOptionChange = (option) => {
    // Muda a seleção entre 'yes' e 'no', permitindo alternância
    setSelectedOption(option);
    if (option === 'no') {
      setProviderName(''); // Limpa o nome da operadora se "Não tenho" for selecionado
    }
  };
  const handleOptionNo = (option) => {
    setSelectedOption(option);
    if (option === 'no') {
      setProviderName(''); // Limpa o nome da operadora se "Não tenho" for selecionado
    }
    navigate('/simulacao/7');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    sessionStorage.setItem('@activePlan', selectedOption);
    if (selectedOption === 'yes') {
      sessionStorage.setItem('@providerName', JSON.stringify(providerName));
    } else if (selectedOption === 'no') {
      sessionStorage.setItem('@providerName', JSON.stringify('Não possui'));
    }

    navigate('/simulacao/7');
  };

  return (
    <>
      <CurrentPlanStyle>
        <section className="currentPlan__wrapper">
          <div className="container col-12">
            <div className="logo-form">
              <img className="logo" src={Logo} alt="Logo" height={75} />
            </div>
            <div className="title__wrapper">
              <h1 className="title">
                Falta só mais um pouco! Tem algum plano ativo?
              </h1>
              <div className="question__wrapper">
                <p className="text" onClick={toggleDropdown}>
                  Por que essa pergunta?{' '}
                  <img
                    className={`arrow ${isDropdownOpen ? 'up' : ''}`}
                    src={cornerRightArrow}
                    alt="Saiba mais"
                  />
                </p>
                <p
                  className={`dropdown-content ${isDropdownOpen ? 'open' : ''}`}
                >
                  Para personalizar planos de saúde adequados ao perfil e
                  necessidades da empresa.
                </p>
              </div>
            </div>
            <div className="buttons__wrapper">
              {selectedOption !== 'yes' && (
                <button
                  className={`button_link ${
                    selectedOption === 'yes' ? 'selected' : ''
                  }`}
                  onClick={() => handleOptionChange('yes')}
                >
                  Sim, tenho
                </button>
              )}
              {selectedOption === 'yes' && (
                <>
                  <div className="operatorQuestion">
                    <label className="questionLabel" htmlFor="operadoraPlano">
                      Qual seu plano atual?
                    </label>
                    <input
                      className="questionInput"
                      type="text"
                      placeholder="Nome da operadora e/ou plano"
                      value={providerName}
                      name="operadoraPlano"
                      onChange={(e) => setProviderName(e.target.value)}
                      required
                    />
                  </div>
                </>
              )}
              <button
                className={`button_link ${
                  selectedOption === 'no' ? 'selected' : ''
                }`}
                onClick={() => handleOptionNo('no')}
              >
                Não tenho
              </button>
              {selectedOption && (
                <button className="sendButton" onClick={handleSubmit}>
                  Enviar
                </button>
              )}
            </div>
          </div>
          <FooterSend />
        </section>
      </CurrentPlanStyle>
    </>
  );
};

export default FormCurrentPlan;
